import { mockComponent } from 'bloko/common/setupMockComponents';

export { default as ColumnsRow } from './ColumnsRow';
export { default as ColumnsWrapper } from './ColumnsWrapper';

export default mockComponent('Column', null, { withChildren: true });
